import {Injectable} from '@angular/core';
import {RxdbRepository} from './rxdb/rxdb.repository';
import {from, Observable, of, switchMap} from 'rxjs';
import {EppSynchronizerService} from './rxdb/synchronizer/epp.synchronizer.service';

export enum EQuoteMode {
    CRM_LINKED_AND_OFFLINE,
    CRM_LINKED_AND_ONLINE,
    CRM_NOT_LINKED_AND_OFFLINE,
    CRM_NOT_LINKED_AND_ONLINE,
}

@Injectable({
    providedIn: 'root'
})
export class StandaloneModeService {

    public eQuoteMode : EQuoteMode ;
    isInitialized: boolean = false;

    constructor(private rxdbRepository: RxdbRepository,
                private eppSynchronizerService: EppSynchronizerService) {

    }

    private initEQuoteMode(){
        const isStandaloneActive = localStorage.getItem('isStandaloneActive') === 'true'
        const isCrmLinked = localStorage.getItem('isCrmLinked') === 'true'
        if(isCrmLinked && isStandaloneActive  ) {
            this.eQuoteMode = EQuoteMode.CRM_LINKED_AND_OFFLINE
        } else if (isCrmLinked && !isStandaloneActive  ){
            this.eQuoteMode = EQuoteMode.CRM_LINKED_AND_ONLINE
        } else if (!isCrmLinked && isStandaloneActive  ){
            this.eQuoteMode = EQuoteMode.CRM_NOT_LINKED_AND_OFFLINE
        } else if (!isCrmLinked && !isStandaloneActive  ){
            this.eQuoteMode = EQuoteMode.CRM_NOT_LINKED_AND_ONLINE
        }
    }

    public isOffline(): boolean {
        return this.eQuoteMode === EQuoteMode.CRM_LINKED_AND_OFFLINE || this.eQuoteMode === EQuoteMode.CRM_NOT_LINKED_AND_OFFLINE;
    }

    public reset(): void {
        this.isInitialized = false;
    }

    public synchronizeStandaloneMode(): Observable<any> {
        this.initEQuoteMode();
        if ((this.eQuoteMode === EQuoteMode.CRM_NOT_LINKED_AND_OFFLINE ||
            this.eQuoteMode === EQuoteMode.CRM_LINKED_AND_OFFLINE)
            && !this.isInitialized) {
            return from(this.rxdbRepository.initDb()).pipe(
                switchMap(()=> {
                    this.isInitialized = true;
                    this.eppSynchronizerService.init(this.eQuoteMode === EQuoteMode.CRM_LINKED_AND_OFFLINE).then(() => {
                        this.eppSynchronizerService.launchSyncPeriodically(this.eQuoteMode === EQuoteMode.CRM_LINKED_AND_OFFLINE);
                    })
                    return of(true);
                })
            )
        }
        return of(true);
    }
}
